function parsePriceValue(value) {
    const number = Number(String(value || '').replace(/,/g, ''));
    return Number.isNaN(number) ? 0 : number;
}

function formatPriceValue(value) {
    return String(Math.round(value));
}

function updatePriceRange(range) {
    const minInput = range.querySelector('[data-price-input-min]');
    const maxInput = range.querySelector('[data-price-input-max]');
    const minSlider = range.querySelector('[data-price-slider-min]');
    const maxSlider = range.querySelector('[data-price-slider-max]');
    const sliderWrap = range.querySelector('.custom-price-range__slider');
    const track = range.querySelector('.custom-price-range__track');

    if (!minInput || !maxInput || !minSlider || !maxSlider || !sliderWrap) return;

    const maxLimit = parsePriceValue(maxSlider.max);
    let minValue = parsePriceValue(minSlider.value);
    let maxValue = parsePriceValue(maxSlider.value);

    if (minValue > maxValue) {
        if (document.activeElement === minSlider) {
            maxValue = minValue;
            maxSlider.value = maxValue;
        } else {
            minValue = maxValue;
            minSlider.value = minValue;
        }
    }

    const minPercent = maxLimit ? (minValue / maxLimit) * 100 : 0;
    const maxPercent = maxLimit ? (maxValue / maxLimit) * 100 : 100;

    // Set variables on the slider wrapper and explicitly on the track
    // to avoid painting/inheritance issues in some browsers.
    sliderWrap.style.setProperty('--price-min', `${minPercent}%`);
    sliderWrap.style.setProperty('--price-max', `${maxPercent}%`);
    if (track) {
        track.style.setProperty('--price-min', `${minPercent}%`);
        track.style.setProperty('--price-max', `${maxPercent}%`);
    }

    minInput.value = minValue > 0 ? formatPriceValue(minValue) : '';
    maxInput.value = maxValue < maxLimit ? formatPriceValue(maxValue) : '';
}

document.addEventListener('input', (event) => {
    const slider = event.target.closest('[data-price-slider-min], [data-price-slider-max]');
    if (!slider) return;

    const range = slider.closest('[data-custom-price-range]');
    updatePriceRange(range);
}, true);

document.addEventListener('focusout', (event) => {
    const input = event.target.closest('[data-price-input-min], [data-price-input-max]');
    if (!input) return;

    const range = input.closest('[data-custom-price-range]');
    const minInput = range.querySelector('[data-price-input-min]');
    const maxInput = range.querySelector('[data-price-input-max]');
    const minSlider = range.querySelector('[data-price-slider-min]');
    const maxSlider = range.querySelector('[data-price-slider-max]');
    const maxLimit = parsePriceValue(maxSlider.max);

    minSlider.value = minInput.value === '' ? 0 : parsePriceValue(minInput.value);
    maxSlider.value = maxInput.value === '' ? maxLimit : parsePriceValue(maxInput.value);
    updatePriceRange(range);
});

document.querySelectorAll('[data-custom-price-range]').forEach(updatePriceRange);

// Extend FacetFiltersForm.renderProductCount to also update #ProductCountDesktop
// (vertical filter product count — the base theme only updates #ProductCountMobile)
document.addEventListener('DOMContentLoaded', () => {
  if (typeof FacetFiltersForm === 'undefined') return;
  const _orig = FacetFiltersForm.renderProductCount.bind(FacetFiltersForm);
  FacetFiltersForm.renderProductCount = function (html) {
    _orig(html);
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const sourceMobile = parsed.getElementById('ProductCountMobile');
    const destDesktop = document.getElementById('ProductCountDesktop');
    if (sourceMobile && destDesktop) {
      destDesktop.textContent = sourceMobile.textContent.trim();
      destDesktop.classList.remove('loading');
    }
  };
});